import React, { Component } from "react";
import DataBackup from "../../Components/BackupCard/BackupCard";
import { connect } from "react-redux";
import Table from "../../Components/Table/Table";
import "./report.css";
import Spinner from "../../Components/UI/Spinner2/Spinner2";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as actionTypes from "../../store/actions/actionTypes";
import { extractAlphabets } from "../../utils";
import axios from "axios";

class Reports extends Component {
  componentDidMount() {
    const isMobileView = window.matchMedia("(max-width: 768px)").matches;
    if (isMobileView) {
      // Code for mobile view
      const sidebar = document.getElementById("sidebar");
      if (sidebar) sidebar.style = "width:0";
    }
  }

  downloadData = (extraInfo = "") => {
    const _idEl = document.getElementById("deviceIdSelect__reports");
    const _id = _idEl ? _idEl.value : "unknown_device";

    let prevParaAsPerType =
      JSON.parse(localStorage.getItem("visibleParaForType")) || {};

    console.log({ prevParaAsPerType });
    const doc = new jsPDF();
    console.log({ _id });
    let type = extractAlphabets(_id);

    try {
      let data = this.props.reportData || {};
      const dataKeys = Object.keys(data || {});
      let data_length = 0;
      if (dataKeys.length > 0 && Array.isArray(data[dataKeys[0]])) {
        data_length = data[dataKeys[0]].length;
      }

      var csv = "",
        csv_header = "";
      var pdf_header = [],
        pdf_data = [],
        data_col = [];

      console.log({ data });

      // build CSV & PDF header (respecting visibleParaForType)
      for (let l in data) {
        console.log({
          type,
          prevParaAsPerType,
          para: prevParaAsPerType[type],
          l,
          inc: l.split(" ").join("_").toLowerCase(),
          condition: prevParaAsPerType[type]?.includes(
            l.split(" ").join("_").toLowerCase()
          ),
          condition2: l.split(" (")[0].toLowerCase(),
        });

        if (prevParaAsPerType[type]) {
          if (
            prevParaAsPerType[type]?.includes(
              l.split(" ").join("_").toLowerCase()
            ) ||
            prevParaAsPerType[type]?.includes(l.split(" (")[0].toLowerCase()) ||
            l === "recorded_time" ||
            l === "recieved_time"
          ) {
            csv_header += l.toUpperCase().replace("_", " ") + ",";
            pdf_header.push(l.toUpperCase().replace("_", " "));
          }
        } else {
          csv_header += l.toUpperCase().replace("_", " ") + ",";
          pdf_header.push(l.toUpperCase().replace("_", " "));
        }
      }

      // consumption: only for UFM and averages daily/monthly/yearly
      let isAverageFlowmeter =
        (this.props.deviceId || "").includes("UFM") &&
        ["daily", "monthly", "yearly"].includes(this.props.average);

      if (isAverageFlowmeter) {
        // add consumption header (no extra comma needed because previous loop added commas after each header)
        csv_header += "CONSUMPTION";
        pdf_header.push("CONSUMPTION");
      }
      csv_header += "\n";

      for (let i = 0; i < data_length; i++) {
        for (let item in data) {
          if (prevParaAsPerType[type]) {
            if (
              prevParaAsPerType[type]?.includes(
                item.split(" ").join("_").toLowerCase()
              ) ||
              prevParaAsPerType[type]?.includes(
                item.split(" (")[0].toLowerCase()
              ) ||
              item === "recorded_time" ||
              item === "recieved_time"
            ) {
              if (String(data[item][i]).includes(",")) {
                data[item][i] = String(data[item][i]).replace(",", " ");
              }
              console.log({ csvData: data[item][i], key: item });

              csv += data[item][i] + ",";
              data_col.push(data[item][i]);
            }
          } else {
            if (String(data[item][i]).includes(",")) {
              data[item][i] = String(data[item][i]).replace(",", " ");
            }
            csv += data[item][i] + ",";
            data_col.push(data[item][i]);
          }
        }

        // consumption value for flowmeters
        if (isAverageFlowmeter) {
          const prevTotal = data?.Totalizer?.[i - 1];
          const curTotal = data?.Totalizer?.[i];
          let consumption = "-";
          if (
            i === 0 ||
            typeof prevTotal === "undefined" ||
            typeof curTotal === "undefined"
          ) {
            csv += "-";
            data_col.push("-");
          } else {
            consumption = Number(curTotal - prevTotal).toFixed(2);
            csv += consumption;
            data_col.push(consumption);
          }
        }

        pdf_data.push(data_col);
        data_col = [];
        csv += "\n";
      }

      csv = csv_header.concat(csv);
      csv = extraInfo.concat(csv);

      if (data_length === 0) {
        // showMessage presumed to be implemented elsewhere in the app
        if (typeof this.showMessage === "function") {
          this.showMessage("Sorry! No data recorded in between these dates");
        } else {
          console.warn("No data available for report.");
        }
      } else {
        if (this.props.fileType === "csv") {
          var hiddenElement = document.createElement("a");
          hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
          hiddenElement.target = "_blank";
          hiddenElement.download = `${_id}_.csv`;
          hiddenElement.click();
        } else if (this.props.fileType === "pdf") {
          doc.deletePage(1);
          doc.addPage("a4", "landscape");

          // If extraInfo provided, print it above the table
          let startY = 10;
          if (extraInfo && extraInfo.length > 0) {
            // format extraInfo for readability in pdf
            let formattedExtra = extraInfo.split(",").join(" : ");
            // respect newlines
            const lines = doc.splitTextToSize(formattedExtra, 280);
            doc.text(lines, 10, 10);
            startY = 10 + lines.length * 8 + 8; // crude spacing based on line count
          }

          doc.autoTable({ head: [pdf_header], body: pdf_data, startY });
          doc.save(`${_id}_.pdf`);
        } else if (this.props.fileType === "xls") {
          // xls export - implement if/when needed
        }
      }
    } catch (ex) {
      console.log(ex);
    }
  };

  viewData = () => {
    let headerRaw = [];
    let isAverage = ["daily", "monthly", "yearly"].includes(this.props.average);
    let isAverageFlowmeter =
      (this.props.deviceId || "").includes("UFM") && isAverage;

    if (isAverageFlowmeter) {
      headerRaw = this.props.reportData && [
        ...Object.keys(this.props.reportData),
        "Consumption",
      ];
    } else {
      headerRaw = this.props.reportData && Object.keys(this.props.reportData);
    }

    console.log({ deviceId: this.props.deviceId, average: this.props.average });
    console.log({ headerRaw });
    const header =
      this.props.reportData &&
      headerRaw.map((item) => item.toUpperCase().replace("_", " "));
    console.log(header);
    let body = [],
      row = [];
    let consumption = "-";

    if (header && headerRaw && headerRaw.length > 0) {
      console.log(this.props.reportData);
      for (
        let i = 0;
        i < (this.props.reportData[headerRaw[0]] || []).length;
        i++
      ) {
        row = headerRaw.map((item) => {
          if (item === "Consumption") {
            if (i === 0) return consumption;
            const prev = this.props.reportData?.Totalizer?.[i - 1];
            const cur = this.props.reportData?.Totalizer?.[i];
            if (typeof prev === "undefined" || typeof cur === "undefined") {
              return "-";
            }
            consumption = Number(cur - prev).toFixed(2);
            return consumption;
          } else {
            return this.props.reportData?.[item]?.[i];
          }
        });

        body.push(row);
        row = [];
      }
    }
    console.log(body);
    return [header, body];
  };

  render() {
    let renderComponent = null;
    console.log(this.props.method);
    console.log(this.props.reportData);
    let header, body;
    const _idEl = document.getElementById("deviceIdSelect__reports");
    const _id = _idEl ? _idEl.value : null;


    


    if (this.props.method === actionTypes.REPORT_DOWNLOAD) {
      let extraInfo = ""; // calibration_date, meterId, serial no, etc

      const token = localStorage.getItem("token");

      if (_id) {


        


        axios
          .get(`${process.env.REACT_APP_BASE_URL}/devices/calibration/${_id}`, {
            headers: {
              "x-api-key": token,
            },
          })
          .then((res) => {
            console.log({ res });
            let data = res.data || {};
            // keep format consistent (CSV-friendly)
            extraInfo = `DEVICE_ID,${data.device_id}\n`;
            // if meter id exists include it (older version had meter_id, file2 didn't)
            if (data.meter_id) {
              extraInfo += `METER/TW_ID, ${data.meter_id}\n`;
            }
            extraInfo += `SERIAL_NO, ${data.meter_serial_no || "-"}\n`;
            extraInfo += `CALIBRATION_DATE, ${
              data.calibration_date || "-"
            }\n\n`;
            this.downloadData(extraInfo);
          })
          .catch((error) => {
            console.log({ error });
            // fallback: download without extraInfo
            this.downloadData();
          });
      } else {
        // no device id DOM element found: just attempt download without extraInfo
        this.downloadData();
      }
    } else if (this.props.method === actionTypes.REPORT_VIEW) {
      [header, body] = this.viewData();
      if (body && header) {
        renderComponent = (
          <div className="col-md-8">
            <div
              className="demo-card-wide neu_card mdl-card "
              themeColor={this.props.dataColor}
              style={{ maxHeight: "500px" }}
            >
              <Table rows={body} headers={header} />
            </div>
          </div>
        );
      }
    }

    if (this.props.loading) {
      renderComponent = (
        <div className="col-md-8">
          <div
            className="demo-card-wide neu_card mdl-card "
            themeColor={this.props.dataColor}
            style={{ maxHeight: "500px" }}
          >
            <Spinner theme="blue" />
          </div>
        </div>
      );
    }

    return (
      <div className="content" style={{ margin: "30px" }}>
        <h4 className="pageTitle" color="light">
          Reports
        </h4>
        <div className="row">
          <div className="col-md-4">
            <div
              className="demo-card-wide neu_card mdl-card"
              themeColor={this.props.dataColor}
            >
              <DataBackup />
            </div>
          </div>
          {renderComponent}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.reports.loading,
    error: state.reports.error,
    reportData: state.reports.reportData,
    method: state.reports.method,
    fileType: state.reports.fileType,
    deviceId: state.reports.deviceId,
    average: state.reports.average,
  };
};

export default connect(mapStateToProps, null)(Reports);
